import { useState } from 'react';

const faqs = [
  {
    question: 'What does HVAC training usually cover in Connecticut?',
    answer: 'Most introductory programs combine safety, tools, refrigeration principles, electrical theory, air distribution, motors, controls, heating systems, cooling systems, preventive maintenance, and system diagnostics. Strong hands-on programs also let students practice reading wiring diagrams, using meters, identifying components, and troubleshooting common equipment problems.',
  },
  {
    question: 'Should I look for EPA Section 608 certification preparation?',
    answer: 'Yes. Technicians who handle regulated refrigerants generally need EPA Section 608 certification. Ask each Connecticut school whether its curriculum prepares students for the appropriate certification exam, whether testing is included, and which certification types the program supports.',
  },
  {
    question: 'Do I need Connecticut licensing to work in HVAC?',
    answer: 'Connecticut licensing requirements depend on the work performed, level of responsibility, and license classification. Ask the school how its training relates to apprenticeship, journeyperson, contractor, and mechanical licensing pathways. Confirm current requirements with the Connecticut Department of Consumer Protection.',
  },
  {
    question: 'How long does it take to complete a Connecticut HVAC program?',
    answer: 'Program length ranges from short continuing-education courses and accelerated certificates to 10- or 12-month private programs and two-year associate degree pathways. Ask about total clock hours, lab hours, attendance requirements, and whether the published timeline assumes full-time enrollment.',
  },
  {
    question: 'What should I ask a school before applying?',
    answer: 'Ask for the complete tuition and fee breakdown, tool costs, books, class times, lab access, instructor experience, EPA preparation, credential details, licensing relevance, apprenticeship opportunities, job placement support, refund policies, admission requirements, and relationships with Connecticut employers.',
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="directory section" id="faq">
      <div className="section-heading">
        <p className="eyebrow">Plan with confidence</p>
        <h2>Connecticut HVAC Training FAQs</h2>
        <p>
          Use these answers as a starting point while comparing Connecticut
          programs. A school representative and the relevant state agencies
          should provide the most current information about curriculum,
          credentials, costs, licensing, and enrollment.
        </p>
      </div>

      <div className="accordion-stack">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <article className={`program-card ${isOpen ? 'open' : ''}`} key={faq.question}>
              <button
                className="program-trigger"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
              >
                <strong>{faq.question}</strong>
                <span aria-hidden="true">{isOpen ? '−' : '+'}</span>
              </button>
              {isOpen && (
                <div className="program-inner">
                  <p>{faq.answer}</p>
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default FAQ;